
import { requester } from "App";
import { textFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputImage from "components/inputs/image/InputImage";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { validateInputs } from "shared/utils/Utils";
import Seperator from "components/Separator";
import style from "./PartnersCategoryCreate.module.css";

function PartnersCategoryCreate() {
    const inputs = useRef([]);
    const { t } = useTranslation();
    const [category, setCategory] = useState();
    const id = 'root';
    const dispatch = useDispatch();

    const onClick = () => {
        let data = { storeId: id, categoryName: "", categoryImage: "" }
        validateInputs(inputs.current).then((result) => {
            if (result.isValid) {
                data.categoryName = inputs.current[0].getValue();
                data.categoryImage = inputs.current[1].getValue();

                requester.createCategory(data, (result) => {

                })
            } else {
                toast.error(t("pleaseCheck"), {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        });
    }

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }

    return (
        <Container>
            <VerticalFlex gap={10} overflow={"scroll"}>
                <FlexChild>
                    <div className={style.container}>
                        <div className={style.flexGrid}>
                            <div className={style.flexBox} >
                                <div className={style.card}>
                                    <div className={style.section}>
                                        <div className={style.sectionTitle}>
                                            <P>기본정보</P>
                                        </div>
                                        <Seperator color={"#dedede"} height={"1px"} />
                                        <div className={style.sectionContent}>
                                            <VerticalFlex flexStart gap={20}>
                                                <FlexChild>
                                                    <HorizontalFlex gap={30}>
                                                        <FlexChild width={"20%"} >
                                                            <P>카테고리명 : </P>
                                                        </FlexChild>
                                                        <FlexChild>
                                                            <InputText ref={el => (inputs.current[0] = el)} placeHolder={"카테고리명"} regExp={[textFormat]} />
                                                        </FlexChild>
                                                    </HorizontalFlex>
                                                </FlexChild>
                                            </VerticalFlex>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={style.flexBox} >
                                <div className={style.card}>
                                    <div className={style.section}>
                                        <div className={style.sectionTitle}>
                                            <P>이미지</P>
                                        </div>
                                        <Seperator color={"#dedede"} height={"1px"} />
                                        <div className={style.sectionContent}>
                                            <InputImage ref={el => (inputs.current[1] = el)} name={"상품 라벨"} path={"category/"} labelWidth={0} cropWidth={150} cropHeight={150} value={category && category.image ? category.image : ""} maxSizeMb={1} />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FlexChild>
                <FlexChild>
                    <CustomButton text={"카테고리등록"} style={btnStyle} onClick={onClick} />
                </FlexChild>
            </VerticalFlex>
        </Container >
    );
} export default PartnersCategoryCreate;